import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ArticleIcon from '@mui/icons-material/Article';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CampaignIcon from '@mui/icons-material/Campaign';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FaceIcon from '@mui/icons-material/Face';
import FactoryIcon from '@mui/icons-material/Factory';
import GavelIcon from '@mui/icons-material/Gavel';
import HighlightIcon from '@mui/icons-material/Highlight';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MoneyIcon from '@mui/icons-material/Money';
import PeopleIcon from '@mui/icons-material/People';
import PieChartIcon from '@mui/icons-material/PieChart';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import SavingsIcon from '@mui/icons-material/Savings';
import ScienceIcon from '@mui/icons-material/Science';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StorageIcon from '@mui/icons-material/Storage';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import WalletIcon from '@mui/icons-material/Wallet';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WarningIcon from '@mui/icons-material/Warning';

import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const getIconFromDriverType = (driverType) => {
    switch (driverType) {
        case 'operatingCost':
            return EngineeringIcon;
        case 'cost':
            return MonetizationOnIcon;
        case 'operatingCapital':
            return WarehouseIcon;
        case 'capitalInvestment':
            return SavingsIcon;
        case 'revenue':
            return TrendingUpIcon;
        case 'sales':
            return CoPresentIcon;
        case 'marketing':
            return HighlightIcon;
        case 'ttm':
            return AccessTimeIcon;
        case 'npm':
            return PieChartIcon;
        case 'clv':
            return LoyaltyIcon;
        case 'risk':
            return WarningIcon;
        case 'regulatory':
            return AssuredWorkloadIcon;
        case 'litigation':
            return GavelIcon;
        case 'revenueLoss':
            return TrendingDownIcon;
        default:
            return MonetizationOnIcon;
    }
};

export const getIconFromDriverName = (driverName) => {

    if (driverName.includes('operational')) {
        return FactoryIcon;
    } else if (driverName.includes('communication')) {
        return CampaignIcon;
    } else if (driverName.includes('business_development')) {
        return BusinessCenterIcon;        
    } else if (driverName.includes('people')) {
        return PeopleIcon;
    } else if (driverName.includes('purchasing')) {
        return ShoppingCartIcon;
    } else if (driverName.includes('infrastructure')) {
        return StorageIcon;
    } else if (driverName.includes('customer_success')) {
        return EmojiEventsIcon;
    } else if (driverName.includes('finance')) {
        return WalletIcon;                                              
    } else if (driverName.includes('capital')) {
        return AccountBalanceIcon;
    } else if (driverName.includes('research')) {
        return ScienceIcon;
    } else if (driverName.includes('compliance')) {
        return GavelIcon;
    } else if (driverName.includes('personnel')) {
        return FaceIcon;
    } else if (driverName.includes('support')) {
        return SupportAgentIcon;
    } else if (driverName.includes('inventory')) {
        return WarehouseIcon;
    } else if (driverName.includes('facilities')) {
        return ApartmentIcon;
    } else if (driverName.includes('production') || driverName.includes('equipment')) {
        return PrecisionManufacturingIcon;
    } else if (driverName.includes('upgrades')) {
        return UpgradeIcon;
    } else if (driverName.includes('sales')) {
        return CoPresentIcon;
    } else if (driverName.includes('marketing')) {
        return HighlightIcon;
    } else if (driverName.includes('lifetime')) {
        return LoyaltyIcon;
    } else if (driverName.includes('time')) {
        return AccessTimeIcon;
    } else if (driverName.includes('incremental')) {
        return PieChartIcon;
    } else if (driverName.includes('payment')) {
        return MoneyIcon;
    } else if (driverName.includes('regulatory')) {
        return AssuredWorkloadIcon;
    } else if (driverName.includes('litigation')) {
        return GavelIcon;
    } else if (driverName.includes('loss')) {
        return TrendingDownIcon;
    } else {
        return ArticleIcon;
    }
};

export const toolTipUserIcon = () => {
    return (
        <Typography sx={{ color: "green", display: 'flex', alignItems: 'center' }}>
            <Tooltip title="User Created" sx={{ m: 1 }}>
                <AccountCircleIcon sx={{ ml: 0.5, fontSize: 14 }} />
            </Tooltip>
        </Typography>
    )
}